import * as Firebase from "firebase";

/* This is here for now because it makes tests fails */
import 'firebase/storage';
/* ------------------------------------------------- */

import FirebaseConfig from "config/firebase";

Firebase.initializeApp(FirebaseConfig);

export const Firestore = Firebase.firestore();
export const Auth = Firebase.auth();
export const Storage = Firebase.storage();
export const Functions = Firebase.functions();
export { Firebase };
